/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type CreateWorkOrderDialogMutationVariables = Types.Exact<{
  status: Types.WorkOrderStatus
  vehicleIDs: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']
  serviceItem: Types.WorkOrderServiceItem
  description?: Types.InputMaybe<Types.Scalars['String']['input']>
  priority?: Types.InputMaybe<Types.WorkOrderPriority>
  dueAt?: Types.InputMaybe<Types.Scalars['DateTime']['input']>
}>

export type CreateWorkOrderDialogMutation = {
  __typename?: 'Mutation'
  createWorkOrders: boolean
}

export const CreateWorkOrderDialogDocument = gql`
    mutation CreateWorkOrderDialog($status: WorkOrderStatus!, $vehicleIDs: [ID!]!, $serviceItem: WorkOrderServiceItem!, $description: String, $priority: WorkOrderPriority, $dueAt: DateTime) {
  createWorkOrders(
    input: {status: $status, vehicleIDs: $vehicleIDs, serviceItem: $serviceItem, description: $description, priority: $priority, dueAt: $dueAt}
  )
}
    `
export type CreateWorkOrderDialogMutationFn = Apollo.MutationFunction<
  CreateWorkOrderDialogMutation,
  CreateWorkOrderDialogMutationVariables
>

/**
 * __useCreateWorkOrderDialogMutation__
 *
 * To run a mutation, you first call `useCreateWorkOrderDialogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkOrderDialogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkOrderDialogMutation, { data, loading, error }] = useCreateWorkOrderDialogMutation({
 *   variables: {
 *      status: // value for 'status'
 *      vehicleIDs: // value for 'vehicleIDs'
 *      serviceItem: // value for 'serviceItem'
 *      description: // value for 'description'
 *      priority: // value for 'priority'
 *      dueAt: // value for 'dueAt'
 *   },
 * });
 */
export function useCreateWorkOrderDialogMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkOrderDialogMutation,
    CreateWorkOrderDialogMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateWorkOrderDialogMutation,
    CreateWorkOrderDialogMutationVariables
  >(CreateWorkOrderDialogDocument, options)
}
export type CreateWorkOrderDialogMutationHookResult = ReturnType<
  typeof useCreateWorkOrderDialogMutation
>
export type CreateWorkOrderDialogMutationResult =
  Apollo.MutationResult<CreateWorkOrderDialogMutation>
export type CreateWorkOrderDialogMutationOptions = Apollo.BaseMutationOptions<
  CreateWorkOrderDialogMutation,
  CreateWorkOrderDialogMutationVariables
>
